// config
import * as http from 'utils/http';
import config from 'config';

const getCarrierUserById = async (carrierUserId) => {
  const data = await http.get(`${config.BASE_ROUTE}api/users/${carrierUserId}`);
  return data;
};

export default getCarrierUserById;
